// extracted by mini-css-extract-plugin
export default {"li":"TempoCount_li__KjC9g"};